import $ from "jquery";
import Util from "./../util";
import Tab from "./../tab";
import Variables from "./../variables";
import GoogleMaps from "./../googlemaps";
import formatNumber from "format-number";
import PropertyModalWidget from "./property-modal-widget";
import infoWindowTemplate from "./templates/list-info-window.html";
import liquidjs from "./../liquidjs";

const PropertyListMapWidget = (($) => {
  const Liquid = new liquidjs.Liquid();

  /** Formatters */
  const formatCurrency = formatNumber({ prefix: "$", round: 2 });
  const formatArea = formatNumber({ suffix: " sqft", round: 0 });

  const NAME = "PropertyListMapWidget";
  const VERSION = "4.1.1";
  const DATA_KEY = "nh.propertyListMapWidget";
  const EVENT_KEY = `.${DATA_KEY}`;
  const DATA_API_KEY = ".data-api";
  const JQUERY_NO_CONFLICT = $.fn[NAME];

  const Defaults = {
    inline: false,
  };

  const Selector = {
    INFO_WINDOW_LINK: ".nhw-map-property-info-window",
  };

  const Api = {
    ENDPOINT: "/_system/api/listings",
  };

  const TemplateTypes = {
    infoWindow: {
      name: "infoWindow",
      default: infoWindowTemplate,
      dataTag: "infoWindow",
    },
  };

  const Templates = {
    INFO_WINDOW:
      '<div class="nesthub-widget nhw-map-property-info-window" data-url="{{systemUrl}}" data-id={{listingID}}>' +
      '<div class="nhw-map-property-info-window-img"><img src="{{imgUrl}}" alt="{{title}}"/></div>' +
      '<div class="nhw-map-property-info-window-detail">' +
      '<div class="nhw-map-property-info-window-amount">{{amount}}</div>' +
      '<div class="nhw-map-property-info-window-beds">{{beds}}</div>' +
      '<div class="nhw-map-property-info-window-baths">{{baths}}</div>' +
      '<div class="nhw-map-property-info-window-area">{{area}}</div>' +
      "</div>" +
      "</div>",
  };

  class PropertyListMapWidget {
    constructor(element, config = {}) {
      this._element = element;
      this._map = null;
      this._propertyModal = null;
      this._config = $.extend(Defaults, $(this._element).data(), config);
      this._cache = {
        templates: {},
      };

      this._init();
    }

    static get VERSION() {
      return VERSION;
    }

    _init() {
      const self = this;
      const inline = this._config.inline;

      $(this._element).on("click", Selector.INFO_WINDOW_LINK, function (event) {
        if (inline) {
          const id = $(this).data("id");

          if (id) {
            if (!self._propertyModal) {
              self._propertyModal = new PropertyModalWidget();
            }
            self._propertyModal.show(id);
          }
        } else {
          const url = $(this).data("url");
          if (url) {
            window.location.href = url;
          }
        }
      });

      let data = $.extend();

      let endpoint = Api.ENDPOINT;

      $.ajax(endpoint, {
        method: "GET",
        data: data,
      }).done((data) => {
        const listings = data.listings;
        for (let i = 0; i < listings.length; i++) {
          if (listings[i].latitude) {
            $(this._element).data("defaultLat", listings[i].latitude);
            $(this._element).data("defaultLng", listings[i].longitude);
            break;
          }
        }

        this._render(listings);
      });
    }

    _getTemplate(type) {
      if (!this._cache.templates[type.name]) {
        this._cache.templates[type.name] = Liquid.parse(type.default);
      }
      return this._cache.templates[type.name];
    }

    _render(data) {
      const self = this;

      this._map = new GoogleMaps(this._element);
      this._map.show(function (map) {
        self._map.onIdle((event) => {
          self._handleMapBoundsChange(event);
        });
        self._updateMarkers(data);
      });
    }

    _handleMapBoundsChange() {
      const self = this;

      if (!this._map) {
        return;
      }

      let mapInfo = this._map.getMapInfo();

      let data = {
        latitudeMin: mapInfo.minLat,
        latitudeMax: mapInfo.maxLat,
        longitudeMin: mapInfo.minLon,
        longitudeMax: mapInfo.maxLon,
      };

      let endpoint = Api.ENDPOINT;

      $.ajax(endpoint, {
        method: "GET",
        data: data,
      })
        .done(function (data, textStatus, jqXHR) {
          self._updateMarkers(data.listings);
        })
        .fail(function (jqXHR, textStatus, errorThrown) {});
    }

    _updateMarkers(data) {
      const self = this;

      if (!this._map) {
        return;
      }

      self._map.clearMarkers();

      data.forEach(function (listing) {
        let marker = self._map.addMarker(
          parseFloat(listing.latitude),
          parseFloat(listing.longitude)
        );
        google.maps.event.addListener(marker, "click", () => {
          self._handleMarkerClick(marker, listing);
        });
      });
    }

    _handleMarkerClick(marker, listing) {
      if (!this._map) {
        return;
      }

      let url = `/${listing.systemUrl}`;
      const data = { ...listing };

      const container = document.createElement("div");

      data.beds =
        listing.beds > 0
          ? listing.beds > 1
            ? listing.beds + " beds"
            : "1 bed"
          : "Studio";
      data.baths = listing.baths != 1 ? listing.baths + " baths" : "1 bath";
      data.area = listing.area > 0 ? formatArea(listing.area) : "";
      data.url = listing.systemUrl;
      data.imgUrl = listing.imageUrl ? `${listing.imageUrl}?size=small` : null;
      data.imgAlt = listing.url;
      data.amount = formatCurrency(listing.rent);

      const template = this._getTemplate(TemplateTypes.infoWindow);
      if (template) {
        Liquid.render(template, data).then((html) => {
          container.innerHTML = html;
          this._map.openInfoWindowOnMarker(container, marker);
        });
      }
    }
  }

  $("[data-ion='listing-map-widget']").each(function (index, element) {
    const $element = $(element);
    let data = $element.data("ion.propertyListMapWidget");

    if (!data) {
      data = new PropertyListMapWidget(element);
      $element.data("ion.propertyListMapWidget", data);
    }

    if (typeof config === "string") {
      if (typeof data[config] === "undefined") {
        throw new TypeError(`No method named "${config}"`);
      }
      data[config]();
    }
  });

  $("[data-ion='listing-inline-map-widget']").each(function (index, element) {
    const $element = $(element);
    let data = $element.data("ion.propertyListMapWidget");

    if (!data) {
      $element.data("inline", true);
      data = new PropertyListMapWidget(element);
      $element.data("ion.propertyListMapWidget", data);
    }

    if (typeof config === "string") {
      if (typeof data[config] === "undefined") {
        throw new TypeError(`No method named "${config}"`);
      }
      data[config]();
    }
  });
})($);

export default PropertyListMapWidget;
